import { render, staticRenderFns } from "./PrototypeAttributeTable.vue?vue&type=template&id=3b53a916"
import script from "./PrototypeAttributeTable.vue?vue&type=script&lang=js"
export * from "./PrototypeAttributeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports